import React from "react";
import {
  useAcceptModificationRequest,
  useFetchCustomerOrderDetails,
  useRejectModificationRequest,
} from "../../hooks/api";
import { useSearchParams } from "react-router-dom";
import {
  MODIFICATION_ORDERS_COLUMN,
  ORDER_STATUSES,
} from "../../constants/constants";
import CustomTable from "../../widgets/Table";
import Loader from "../../components/Loader/Loader";
import { useSnackbarContext } from "../../widgets/CustomSnackBar/CustomSnackBar";

import "./OrderModification.css";

const handleOnClickAcceptButton = (mutateFn, orderId, openSnackbar) => {
  mutateFn(orderId, {
    onSuccess: (data) => {
      openSnackbar("Order modification accepted", "success");
      window.location.reload();
    },
    onError: (error) => {
      openSnackbar(error.message || "Failed to accept modification", "error");
    },
  });
};

const handleOnClickRejectButton = (mutateFn, orderId, openSnackbar) => {
  mutateFn(orderId, {
    onSuccess: (data) => {
      openSnackbar("Order modification rejected", "warning");
      window.location.reload();
    },
    onError: (error) => {
      openSnackbar(error.message || "Failed to reject modification", "error");
    },
  });
};

const getModificationDetails = (
  modificationRequestOrders,
  acceptRequest,
  rejectRequest,
  isAccepting,
  isRejecting,
  openSnackbar
) => {
  if (!Array.isArray(modificationRequestOrders)) {
    return [];
  }

  return modificationRequestOrders.map((orderDetails) => ({
    orderId: orderDetails?.order_id ?? "N/A",
    amount: orderDetails?.inr_conversion_amount
      ? Number(orderDetails.inr_conversion_amount).toLocaleString("en-IN")
      : "—",
    orderStatus: orderDetails?.status?.name ?? "Unknown",
    actions: (
      <>
        <button
          className="acceptButton"
          onClick={() =>
            handleOnClickAcceptButton(
              acceptRequest,
              orderDetails.order_id,
              openSnackbar
            )
          }
          disabled={isAccepting}
        >
          Accept
        </button>
        <button
          className="rejectButton"
          onClick={() =>
            handleOnClickRejectButton(
              rejectRequest,
              orderDetails.order_id,
              openSnackbar
            )
          }
          disabled={isRejecting}
        >
          Reject
        </button>
      </>
    ),
  }));
};

const OrderModification = () => {
  const [searchParams] = useSearchParams();
  const { openSnackbar } = useSnackbarContext();
  const uamId = searchParams.get("uamId");

  const {
    isPending: isOrderDetailsLoading,
    data: orderDetails,
    error: orderDetailsError,
    isError: isErrorFetchingOrderDetails,
  } = useFetchCustomerOrderDetails(uamId);

  const { mutate: acceptRequest, isPending: isAccepting } =
    useAcceptModificationRequest();
  const { mutate: rejectRequest, isPending: isRejecting } =
    useRejectModificationRequest();

  const modificationRequestOrders =
    orderDetails?.filter(
      (order) => order.status.id === ORDER_STATUSES.SUSPENDED
    ) || [];

  const rows = getModificationDetails(
    modificationRequestOrders,
    acceptRequest,
    rejectRequest,
    isAccepting,
    isRejecting,
    openSnackbar
  );
  if (isOrderDetailsLoading) {
    <Loader />;
  }
  return (
    <div className="container">
      <div className="title">Order Modification</div>
      {modificationRequestOrders.length === 0 ? (
        "No modification requests"
      ) : (
        <CustomTable rows={rows} columns={MODIFICATION_ORDERS_COLUMN} />
      )}
      {isErrorFetchingOrderDetails && (
        <div style={{ color: "red" }}>{orderDetailsError.message}</div>
      )}
    </div>
  );
};

export default OrderModification;
